import { MaintenanceAspectService } from '../model/maintenance-aspect.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { MaintenanceAspect } from 'assets-model';
import { Observable } from 'rxjs';


export class MaintenanceAspectDataSource extends CrudDataSource<MaintenanceAspect> {

  constructor(private service: MaintenanceAspectService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<MaintenanceAspect>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


